import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { app } from '../firebase';

let appCheckPromise = null;

const initFirebaseAppCheck = () => {
  if (!appCheckPromise) {
    appCheckPromise = new Promise((resolve, reject) => {
      try {
        const recaptchaEnterpriseSiteKey = process.env.REACT_APP_FIREBASE_RECAPTCHA_ENTERPRISE_SITE_KEY
        const appCheck = initializeAppCheck(app, {
          provider: new ReCaptchaEnterpriseProvider(recaptchaEnterpriseSiteKey),
          isTokenAutoRefreshEnabled: true,
        });
        resolve(appCheck);
      } catch (err) {
        console.warn('App Check init failed or already initialized:', err.message);
        reject(err);
      }
    });
  }
  return appCheckPromise;
};

export default initFirebaseAppCheck;